import { getPropertyValues } from '../helpers'
import useGroupData from './useGroupData'

export default function useVolumeSetMetadata() {
  const { initialGroup: volumeSet } = useGroupData()

  if (volumeSet?.types?.[0] !== 'VOLUME_SET') {
    return null
  }

  const authors = getPropertyValues('author', volumeSet.properties).map((value) =>
    value.replace(/ - (added|main) author/i, '')
  )

  let englishSummary = ''
  const notes = getPropertyValues('titleNote', volumeSet.properties).reduce((acc, note) => {
    const key = note.match(/^[a-z /]+: /i)

    if (key?.[0] === 'English Summary: ') {
      englishSummary = note.replace(key, '')
      return acc
    }

    return [...acc, note.replace(key, '')]
  }, [])

  if (englishSummary) {
    notes.push(englishSummary)
  }

  return {
    ancestralHall: volumeSet.ancestralHall,
    authors,
    clan: volumeSet.clan,
    clanBranches: volumeSet.clanBranches,
    firstAncestor: volumeSet.firstAncestor,
    generationPoem: volumeSet.generationPoem,
    migrantAncestor: volumeSet.migrantAncestor,
    notes,
    surnames: getPropertyValues('surname', volumeSet.properties).join(', '),
    title: volumeSet.volumeSetTitle,
    volumeCount: volumeSet.childGroups?.length,
  }
}
